import Vue from 'vue'
import VueAxios from 'vue-axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import * as echarts from 'echarts'
import App from './App.vue'
import router from './router'
import 'normalize.css';
import axios from './http';
import Clipboard from 'clipboard';
import moment from 'moment';
import 'material-design-icons/iconfont/material-icons.css'

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.prototype.Clipboard = Clipboard;

const eventBus = new Vue();
Vue.prototype.$eventBus = eventBus;

Vue.use(VueAxios, axios)
Vue.use(ElementUI);

Vue.filter("separateNum", function (str: string) {
  if (!str) {
    return "0"
  }
  str = str.toString();
  let counter = 0;
  let result = "";
  for (let j = str.length - 1; j >= 0; j--) {
    counter++;
    result = str.charAt(j) + result;
    if (!(counter % 3) && j != 0) { result = ',' + result; }
  }
  if (result == "") {
    return "0";
  }
  return result;
})

Vue.filter("dateFormat", function (timestamp: number) {
  if (!timestamp) {
    return ""
  }
  return moment(1000 * timestamp).format("YYYY-MM-DD")
})


new Vue({
  data: { isLogin: false, status: 0 },
  router,
  render: h => h(App)
}).$mount('#app')
